export const FETCH_DC_APP_PARENT_MAPPING_BY_PARTNER = 'FETCH_DC_APP_PARENT_MAPPING_BY_PARTNER';
